// @flow
import Component from './component'
export default () => ({
  path: 'collect-annual-fees',
  element: <Component />,
})
